<template>
  <div class="marginApplicationPage" v-if="!showLoad">
    <div class="wrap">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.applicantIdName"
          v-if="mode != 'add'"
          readonly
          label="申请人："
          class="ggInput"
        />
        <van-field
          v-model="userinfo.realName"
          class="ggInput"
          input-align="right"
          readonly
          v-else
          label="申请人："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.applyTime"
          label="申请时间："
          readonly
          :placeholder="editType ? '请选择' : ''"
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>

      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="propertyData.amount"
          :placeholder="editType ? '请输入...  ' : ''"
          :readonly="!editType"
          class="ggInput"
          input-align="right"
          clearable
          type="number"
          v-enterIntNumber
          required
          label="金额（元）："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="propertyData.reason"
          :placeholder="editType ? '请输入...  ' : ''"
          class="ggInput"
          input-align="right"
          clearable
          :readonly="!editType"
          required
          label="用款原因："
          rows="1"
          autosize
          type="textarea"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="paymentTypeName"
          class="ggInput"
          input-align="right"
          readonly
          required
          label="支付方式："
          :is-link="editType"
          @click="showPaymentType"
          :placeholder="editType ? '请选择' : ''"
        />
      </van-cell-group>
      <div
        v-if="
          propertyData.paymentType == 'zz' || propertyData.paymentType == 'hp'
        "
      >
        <van-cell-group class="baseNone baseSalary beizhu">
          <van-field
            v-model="propertyData.depositBank"
            class="ggInput"
            input-align="right"
            clearable
            :readonly="!editType"
            rows="1"
            autosize
            type="textarea"
            required
            label="开户银行："
            :placeholder="editType ? '请输入...  ' : ''"
          />
        </van-cell-group>
        <van-cell-group class="baseNone baseSalary">
          <van-field
            v-model="propertyData.proceedsAccount"
            class="ggInput"
            input-align="right"
            clearable
            :readonly="!editType"
            required
            label="收款账号："
            :placeholder="editType ? '请输入...  ' : ''"
          />
        </van-cell-group>
      </div>

      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="propertyData.proceedsCompany"
          clearable
          rows="1"
          autosize
          type="textarea"
          class="ggInput"
          input-align="right"
          :readonly="!editType"
          required
          label="收款单位："
          :placeholder="editType ? '请输入...  ' : ''"
        />
      </van-cell-group>

      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
        :value="propertyData.type=='tb'?'投标保证金':propertyData.type=='ly'?'履约保证金':propertyData.type=='ly_bh'?'履约保函保证金':propertyData.type=='yfk_bh'?'预付款保函保证金':''"
          label="保证金类型："
          :required="editType"
          readonly
          :placeholder="editType ? '请选择' : ''"
          class="ggInput"
          input-align="right"
          :is-link="editType"
          :rules="[{ required: true, message: ' ' }]"
          @click="showTypePickerFun"
        />
      </van-cell-group>
      <!-- 所属项目 -->
      <van-cell-group
        class="itemSite baseNone beizhu"
        v-if="propertyData.type != 'tb'"
      >
        <van-field
          v-model="propertyData.linkName"
          type="textarea"
          class="ggInput"
          input-align="right"
          label="所属项目："
          :required="editType"
          :placeholder="editType ? '请选择' : ''"
          @click="checkItemPicker"
          readonly
          :is-link="editType"
          rows="1"
          autosize
        />
      </van-cell-group>
      <van-cell-group
        class="itemSite baseNone beizhu"
        v-if="propertyData.type == 'tb'"
      >
        <van-field
          v-model="propertyData.linkName"
          type="textarea"
          class="ggInput"
          input-align="right"
          label="所属投标："
          required
          :placeholder="editType ? '请选择' : ''"
          @click="checkBiddingPicker"
          readonly
          :is-link="editType"
          rows="1"
          autosize
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="propertyData.payTime"
          label="要求支付时间："
          readonly
          required
          :placeholder="editType ? '请选择' : ''"
          :rules="[{ required: true }]"
          class="ggInput"
          input-align="right"
          :is-link="editType"
          @click="showTimePickerFun('payTime')"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="propertyData.expectReturnTime"
          label="预计退还时间："
          readonly
          :placeholder="editType ? '请选择' : ''"
          class="ggInput"
          input-align="right"
          :rules="[{ required: true }]"
          @click="showTimePickerFun('expectReturnTime')"
          :is-link="editType"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="propertyData.remarks"
          clearable
          rows="1"
          class="ggInput"
          input-align="right"
          :readonly="!editType"
          autosize
          type="textarea"
          label="备注："
          :placeholder="editType ? '请输入...  ' : ''"
        />
      </van-cell-group>
      <!-- 审批流程 -->
      <div
        class="approveList"
        v-if="this.mode != 'add' && propertyData.verifyStatus != 'hold'"
      >
        <audit-list :applicantData="propertyData"></audit-list>
      </div>

      <!-- 流程图 -->
      <div
        class="flowList"
        v-if="this.mode != 'add' && propertyData.verifyStatus != 'hold'"
      >
        <flow-staff :applicantData="propertyData"></flow-staff>
        <flow-list :workflowCode="propertyData.workflowCode"></flow-list>
      </div>
      <!-- 审批 -->
      <van-popup
        v-model="verifyPageType"
        closeable
        round
        close-icon="close"
        position="bottom"
        class="verifyPage"
      >
        <verify-main
          :applicantData="propertyData"
          @changeVerifyType="setVerifyType"
        ></verify-main>
      </van-popup>
    </div>
    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput"
        class="btn"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="propertyData.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              class="btn"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput"
              class="btn"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="propertyData.verifyStatus == 'deny'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput"
          class="btn"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        propertyData.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        class="btn"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          propertyData.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          propertyData.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">{{
        verifyPageText
      }}</van-button>
    </div>
    <!-- 弹出框 -->
    <!-- 时间控件 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @cancel="showTimePicker = false"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>
    <!-- 项目管理 -->
    <van-popup v-model="showItemPicker" position="bottom" class="roleBox">
      <project-view @setItems="setProject"></project-view>
    </van-popup>
    <!-- 投标管理 -->
    <van-popup v-model="showBiddingPicker" position="bottom" class="roleBox">
      <bidding-view @setItems="setBidding"></bidding-view>
    </van-popup>
    <!-- 报销类型选择器 -->
    <van-popup v-model="showTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="marginType"
        value-key="name"
        @cancel="showTypePicker = false"
        @confirm="saveType"
      />
    </van-popup>
    <!-- 付款方式 -->
    <van-popup v-model="showPaymentTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="showPaymentTypeList"
        value-key="dictName"
        @cancel="showPaymentTypePicker = false"
        @confirm="savePaymentLevel"
      />
    </van-popup>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");
const flowList = () => import("@/components/common/flowList");
const flowStaff = () => import("@/components/common/flowStaff");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
const projectView = () => import("./components//projectView");
const biddingView = () => import("@/components/businessTripMould/biddingView");
import { dateFormat, getDictList, isEdit } from "@/utils/common";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
export default {
  name: "marginApplication",
  data() {
    return {
      editType: false, //能否编辑
      timeType: "", //时间类型
      mode: "add",
      currentDate: new Date(), //当前时间
      minDate: new Date(2000, 1, 1),
      maxDate: new Date(), //当前时间
      showTimePicker: false, //时间控件
      showItemPicker: false, //所属项目弹框
      showBiddingPicker: false, //所属投标弹框
      showTypePicker: false, //类型弹出框

      refreshPage: false, // 网络请求失败时显示
      addType: false, //防止高频点击
      paymentTypeName: "", //付款Name
      propertyData: {
        applyTime: "", //申请时间
        linkName: "", //项目名称
        linkId: "", //项目编号id
        type: "", //保证金类型
        amount: "", //保证金金额
        payTime: "", //要求支付时间
        expectReturnTime: "", //预计退还时间
        reason: "", //用款原因
        proceedsCompany: "", //收款单位
        proceedsAccount: "", //收款账号
        applicantIdName: "",
        remarks: "", //备注
        depositBank: "", //开户行
        paymentType: "", //付款方式
        remarks: "", //备注
        verifyStatus: "hold",
      },
      showPaymentTypePicker: false, //转账方式弹框
      showPaymentTypeList: [
        {
          dictName: "转账",
          dictCode: "zz",
        },
        {
          dictName: "现金",
          dictCode: "xj",
        },
        {
          dictName: "汇票",
          dictCode: "hp",
        },
        {
          dictName: "保函",
          dictCode: "bh",
        },
      ], //转账方式列表
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      clientType: getDeviceType(),
      sendType: "", //判断是否在抄送列表
    };
  },
  async mounted() {
    if (is_wei()) {
      document.title = "保证金申请";
    }
    let time = dateFormat(new Date());
    this.$set(this.propertyData, "applyTime", time);
    this.$set(this.propertyData, "applicantIdName", this.userinfo.realName);
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.verifyType = this.$route.query.verifyType;
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.editType = this.mode == "add" ? true : false;
    window.editPage = this.editPage; //编辑页面
    window.verifyPage = this.verifyPage; //审核页面
    this.$nextTick(() => {
      this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
      if (this.userinfo && this.userinfo.id) {
        if (this.mode == "add") {
          this.setShowLoad(false);
        } else {
          this.initPage();
        }
      }
    });
  },
  components: {
    refreshPage,
    auditList,
    flowList,
    projectView,
    biddingView,
    verifyMain,
    flowStaff,
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    initPage() {
      this.setShowLoad(false);
      let _this = this;
      _this.$api.finance.margin
        .detail(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.propertyData = newApi.assign(
              {},
              _this.propertyData,
              res.data
            );
            if (_this.propertyData.expectReturnTime == null) {
              _this.$set(_this.propertyData, "expectReturnTime", "");
            }
            if (_this.propertyData.remarks == null) {
              _this.$set(_this.propertyData, "remarks", "");
            }
            _this.getPaymentTypeName(_this.propertyData.paymentType);

            let type = isEdit(_this.propertyData.verifyStatus, _this.mode);
            if (
              (_this.propertyData.verifyStatus == "hold" ||
                _this.propertyData.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    getPaymentTypeName(type) {
      let _this = this;
      if (type == "zz") {
        _this.paymentTypeName = "转账";
      } else if (type == "xj") {
        _this.paymentTypeName = "现金";
      } else if (type == "hp") {
        _this.paymentTypeName = "汇票";
      }else if (type == "bh") {
        _this.paymentTypeName = "保函";
      }
    },
    editPage() {
      //需要编辑
      this.editType = true;
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
    showPaymentType() {
      //判断当前是否编辑状态
      if (this.editType) {
        this.showPaymentTypePicker = true;
      }
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    savePaymentLevel(data) {
      this.showPaymentTypePicker = false;
      this.paymentTypeName = data.dictName;
      this.propertyData.paymentType = data.dictCode;
    },

    TimePicker() {
      if (this.editType) {
        this.showTimePicker = true;
      }
    },
    // 撤回和删除
    delApply() {
      let _this = this;
      let text = this.propertyData.verifyStatus == "hold" ? "删除" : "撤回";
      this.$dialog
        .alert({
          title: text,
          message: "你确定" + text + "吗?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.finance.margin
            .deleteRecall(this.propertyData.verifyStatus, _this.propertyData.id)
            .then((res) => {
              if (res.code == "1") {
                let msg = text + "成功";
                closePage(text);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              console.log(err);
              _this.btnLoading = false;
              _this.$toast("网络失败，请稍后重试");
            });
        });
    },
    onTimeConfirm(data) {
      this.showTimePicker = false;
      let time = dateFormat(data);
      this.$set(this.propertyData, this.timeType, time);
    },
    saveType(data) {
      this.showTypePicker = false;
      this.$set(this.propertyData, "typeName", data.name);
      this.$set(this.propertyData, "type", data.value);
      console.log(data);
    },
    showTimePickerFun(timeType) {
      if (this.editType) {
        this.showTimePicker = true;
        this.timeType = timeType;
      }
    },
    showTypePickerFun(index) {
      //打开类型选择弹窗
      if (this.editType) {
        this.showTypePicker = true;
        this.typeIndex = index;
      }
    },
    //项目信息
    checkItemPicker() {
      if (this.editType) {
        this.showItemPicker = true;
      }
    },
    //投标信息
    checkBiddingPicker() {
      if (this.editType) {
        this.showBiddingPicker = true;
      }
    },
    setProject(data) {
      //获取所属项目
      if (data != "") {
        console.log(data);
        this.propertyData.linkId = data.id;
        this.propertyData.linkName = data.name;
      }
      this.showItemPicker = false;
    },
    setBidding(data) {
      //获取所属投标项目
      if (data != "") {
        console.log(data);
        this.propertyData.linkId = data.id;
        this.propertyData.linkName = data.name;
      }
      this.showBiddingPicker = false;
    },
    //保存
    checkInput() {
      let _this = this;
      if (this.validate()) {
        let params = this.propertyData;
        _this.btnLoading = true;
        _this.$api.finance.margin
          .update(this.mode, params)
          .then((res) => {
            if (res.code == "1") {
              let text = this.mode == "add" ? "添加成功" : "编辑成功";
              closePage(text);
            } else {
              _this.$toast(res.msg);
            }
            _this.btnLoading = false;
          })
          .catch((err) => {
            console.log(err);
            _this.btnLoading = false;
            _this.$toast("网络失败，请稍后重试");
          });
      }
    },
    validate() {
      let _this = this;
      if (
        this.propertyData.type == "" ||
        this.propertyData.amount == "" ||
        this.propertyData.payTime == "" ||
        this.propertyData.reason == "" ||
        this.propertyData.paymentType == "" ||
        this.propertyData.proceedsCompany == "" ||
        (this.propertyData.paymentType == "zz" &&
          this.propertyData.proceedsAccount == "") ||
        (this.propertyData.paymentType == "zz" &&
          this.propertyData.depositBank == "") ||
        (this.propertyData.paymentType == "hp" &&
          this.propertyData.proceedsAccount == "") ||
        (this.propertyData.paymentType == "hp" &&
          this.propertyData.depositBank == "") ||
        (this.propertyData.type == "ly" && this.propertyData.linkName == "") ||
        (this.propertyData.type == "tb" && this.propertyData.linkName == "")
      ) {
        _this.$toast("请完善表单信息");
        return false;
      }
      return true;
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function (val) {
        if (val && val.id) {
          if (this.mode == "add") {
            this.setShowLoad(false);
          } else {
            this.initPage();
          }
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.marginApplicationPage {
  width: 100%;
  min-height: 100%;
  background-color: #fff;
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 15px;
    // overflow-y: initial;
  }
  #searchHeight {
    text-align: left;
  }
  .baseNone {
    .ggInput {
      border-bottom: 1px solid #ebedf0;
    }
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
    .ggInput.van-cell::after {
      content: none;
    }
  }
  .baseNone.moreText {
    .van-cell {
      .van-cell__title {
        width: 140px;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .baseNone::after {
    content: none;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }

  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
}
</style>